import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { BillersService } from 'src/app/services/billers.service';
import { CommonService } from 'src/app/services/common.service';
import { SendMoneyService } from '../send-money/send-money.service';

@Component({
  selector: 'app-dcintrac-send-successful',
  templateUrl: './dcintrac-send-successful.component.html',
  styleUrls: ['./dcintrac-send-successful.component.scss']
})
export class DcintracSendSuccessfulComponent implements OnInit {
  trans_key=""

  @Input() public amount

  constructor(public activatedRoute:ActivatedRoute,private messageService: MessageService,public common:CommonService, public sendMoneyService:SendMoneyService, private auth : AuthService, public billerService :BillersService) { }

  ngOnInit(): void {
    this.common.stopLoader()
    this.trans_key = this.activatedRoute.snapshot.paramMap.get("trans_key")
    this.amount = this.sendMoneyService.transactionDetails?.final_amount_interac || this.billerService.successAmount
    this.amount = (+this.amount).toFixed(2)
    if(this.sendMoneyService.transactionDetails?.coupon_id)
   { 
       this.sendMoneyService.usedCoupon(this.sendMoneyService.transactionDetails.coupon_id, this.auth.user.id).subscribe(res => {
        //console.log(res)
      })
    }
  }


  copyMessage() {
    //console.log(this.trans_key)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.trans_key;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.messageService.add({severity:'success', summary:'Copied', detail:""});
    //console.log("link copied!")
  }

}
